const getTwitterShareUrl = options => (
  `https://twitter.com/intent/tweet?text=${options.message}&url=${options.url}`
);

const getFacebookShareUrl = options => (
  `https://www.facebook.com/sharer/sharer.php?u=${options.url}`
);

const getPintrestShareUrl = options => (
  `https://pinterest.com/pin/create/button/?url=${options.url}&media=${options.imgUrl}&description=${options.caption}`
);

const getEmailShareUrl = options => (
  `mailto:?subject=${options.message}&body=Photo%20link%3A%20${options.url}%0A%0AAbout%20this%20photo%3A%20'${options.caption}`
);

const swatchbookAddButton = '<div class="icon icon--plus--white"></div><span>Add to Favorites</span>';

const swatchbookRemoveButton = '<div class="icon icon--minus"></div><span>Remove from Favorites</span>';

const imageShareButtons = `<div class="heading--xxs m-b-xxs">Share Photo</div>
  <div>
    <a href="" class="share-fb-link link m-r-xxs" id="share-fb" target="_blank">Facebook</a>
    <a href="" class="share-tw-link link m-r-xxs" id="share-tw" target="_blank">Twitter</a>
    <a href="" class="share-pt-link link m-r-xxs" id="share-pt" target="_blank">Pinterest</a>
    <a href="" class="share-em-link link" id="share-em" target="_blank">Email</a>
  </div>`;

const modalPhotoCaption = (captionClass, desc, imgUrl) => (
  `<div class="c-caption ${captionClass}">
    <div class="c-caption__header d-flex">
      <button class="c-caption__header__left nav--secondary caption-titlebar-btn caption-titlebar" aria-expanded="true">
        <span class="icon icon--triangle"></span>
        <span>About this Photo</span>
      </button>
      <button class="btn btn-primary o-iconBtn add-photo-btn p-0" data-image="${imgUrl}">
        ${swatchbookRemoveButton}
      </button>
    </div>
    <div class="c-caption__inner">
      <div class="c-caption__left">
        <div class="heading--xxs m-b-xxs">Product Description</div>
        <div class="body--regular">${desc}</div>
      </div>
      <div class="c-caption__right">
        ${imageShareButtons}
      </div>
    </div>
  </div>`
);

export {
  getTwitterShareUrl,
  getFacebookShareUrl,
  getPintrestShareUrl,
  getEmailShareUrl,
  modalPhotoCaption,
  swatchbookAddButton,
  swatchbookRemoveButton,
};
